import { HttpFSWalletAccountRepository } from '../../../../data/repository/fs-wallet-account/http-fs-wallet-account.repository';
import { FSWalletAccountRepository } from '../../../repository/fs-wallet-account.repository';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const WalletAccountHttpProvider = [
  { provide: FSWalletAccountRepository, useClass: HttpFSWalletAccountRepository },
];
